import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IStudent } from '@app/modules/compliance/model/student';
import { NgxPermissionsService } from 'ngx-permissions';
import { IStudentSearchResult } from '../../model/studentSearchResult';
import { ExportService } from '@app/shared/services/exportservice';
import { ReportsService } from '../../../reports/services/reports.service';
import { IAdmissionStatusReportParam } from '../../../reports/model/admissionStatusReportParam';
import { emptyAdmissionStatusReportParam } from '@app/modules/compliance/constants/prepareEmptyObject';

@Component({
    selector: 'search-sidenav',
    templateUrl: 'search-sidenav.component.html',
    styleUrls:["./search-sidenav.component.scss"]
})

export class SearchSidenavComponent implements OnInit {
    public ReadCompliance:boolean=false;
    public ReadFinancialAid:boolean=false;
    public ReadProspective:boolean=false;
    public ReadCertification:boolean=false;
    public admissionStatusReportParam:IAdmissionStatusReportParam=emptyAdmissionStatusReportParam();
    @Input() student: IStudent;
    constructor(  
        private router: Router,
        private _permissionservice: NgxPermissionsService,
        private _exportService:ExportService
        ,private _reportService:ReportsService) { }

    ngOnInit() { 
        this.getPermission();
    }

    editStudent(student: IStudent) {
        this.router.navigate(['/compliance', ''], { queryParams: {id: student.studentId}});
    }
    notesStudent(student: IStudent){
        this.router.navigate(['/compliance', 'notes'], { queryParams: {id: student.studentId}});
    }
    prospectiveStudent(student: IStudent) {
        this.router.navigate(['/prospective'], { queryParams: {id: student.studentId}});
    }
    documentsStudent(student: IStudent) {
        this.router.navigate(['/compliance', 'documents'], { queryParams: {id: student.studentId}});
    }
    certification(student: IStudent) {
        this.router.navigate(['/certification','courseEnrollment'], { queryParams: {id: student.studentId}});
    }
    financialAid(student: IStudent) {
        this.router.navigate(['/financialaid'], { queryParams: {id: student.studentId}});
    }
    admissionStatusReport(student: IStudent)
    {
        this.admissionStatusReportParam.sportSeasonId = student.lastSportSeasonId;
        this.admissionStatusReportParam.studentId = student.studentId;
        this._reportService.admissionStatusReport(this.admissionStatusReportParam).subscribe(data => {
            this._exportService.downloadPdf(data,"AdmissionStatusReport_"+student.institutionId);
          });
    }

    getPermission() {
        this._permissionservice.hasPermission("read:compliance").then(data=>{
          this.ReadCompliance=data;
        });   
        this._permissionservice.hasPermission("read:financialaid").then(data=>{
          this.ReadFinancialAid=data;
        });    
        this._permissionservice.hasPermission("read:prospective").then(data=>{
            this.ReadProspective=data;
          }); 
        this._permissionservice.hasPermission("read:certification").then(data=>{
            this.ReadCertification=data;
          }); 
      }  
}